<template>
  <div class="overlay-full-visa overlay-fireworks-visa "  id="overlay-fireworks-visa">
    <div class="overlay-content">
      <img src="/images/firework-visa-world-tour.png" class="top-icon-fireworks-visa" />
      <p class="congrats" id="fireworks-greetings">¡Visa aprobada para <span id="fireworks-visa-student-name"></span>!</p>
      <div class="consultant-image">
        <img src="" alt="" id="fireworks-visa-img-visa-guide">
        <img src="" alt="" id="fireworks-visa-img-admission-guide" style="display: none">
      </div>
      <p>Gracias "<span id="fireworks-visa-name-visa-guide"></span>" <span id="fireworks-visa-single-name-only">and "<span id="fireworks-visa-name-admission-guide"></span>" </span>!</p>
      <p>Han dado inicio a una nueva aventura en <span id="fireworks-visa-destination"></span></p>
      <div class="close-fireworks-visa">
        <a href="#" id="fireworks-close-visa" @click.prevent="closeOverlay()"><i class="far fa-times-circle"></i></a>
      </div>
    </div>
  </div>
</template>
<style scoped>
.black-bg{
  background-color: #111;
}

.top-icon-fireworks-visa{
  position: absolute;
  top: 0;
  left: 50%;
  width: 160px;
  height: 160px;
  transform: translate(-50%, -80px);
}

.overlay-full-visa{
  position: fixed; /* Sit on top of the page content */
  top: 0;
  left: 0;
  display: none; /* Hidden by default */
  width: 100vw; /* Full width (cover the whole page) */
  height: 100vh; /* Full height (cover the whole page) */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
  .overlay-content {
    position: relative;
    top: 30%;
    text-align: center;
    .title {
      font-size: 30px;
    }
    .avatar {
      width: 150px;
      height: 150px;
    }
    p {
      color: #ffffff;
      font-size: 25px;
    }
  }
}
.overlay-fireworks-visa {
  .overlay-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 24px;
    background: #7070F2;
    width: 1000px;
    padding-top: 40px;
    padding-bottom: 40px;
    text-align: center;
    backdrop-filter: blur(30px);
    .consultant-image {
      img {
        max-width: 100px;
        border-radius: 50px;
      }
    }
    .congrats {
      font-size: 48px;
      color: #ffffff;
      line-height: 1;
      margin-top: 51px;
      margin-bottom: 26px;
    }
    p {
      color: #ffffff;
      font-size: 25px;
      margin-bottom: 0;
      line-height: 1.2;
    }
    .close-fireworks {
      a {
        font-size: 39px;
        color: #ffffff;
      }
    }
    .close-fireworks-visa {
      margin-top:24px;
      a {
        font-size: 36px;
        color: #ffffff;
      }
    }
  }
}
</style>
<script>
import { eventBus, hideOverlay } from "../../utils/helpers";
import { loadAnimation } from "../../utils/confetti";

export default {
  name: "OverlayFireworksVisa",
  data() {
    return {
      show: false,
      confetti: null
    }
  },
  mounted() {
    eventBus.$on('show-fireworks-visa', (event) => {
      this.show = true;

      if(event.admissionGuideName){
        $("#fireworks-visa-img-admission-guide").attr("src", event.admissionGuideImage)
        $("#fireworks-visa-img-admission-guide").show()
        $('#fireworks-visa-name-admission-guide').html(`<b>${event.admissionGuideName}</b>(Admission)`)
      }
      else{
        $('#fireworks-visa-single-name-only').html(``)
      }
      if(event.visaGuideName){
        $('#fireworks-visa-name-visa-guide').html(`<b>${event.visaGuideName}</b>(Visas Guide)`)
        $("#fireworks-visa-img-visa-guide").attr("src", event.visaGuideImage)
      }
      $('#fireworks-visa-student-name').html(`<b>${event.studentName}</b>`)
      $('#fireworks-visa-destination').html(`<b>${event.destination}</b>`)
      $('#overlay-fireworks-visa').show()

      this.startFireworks();
    });
  },
  methods: {
    startFireworks() {
      const parent = document.getElementById('overlay-fireworks-visa');
      let confettiContainer = document.getElementById('confetti-animation');

      if (!confettiContainer) {
        confettiContainer = Object.assign(document.createElement('div'), { id: 'confetti-animation' });
        parent.appendChild(confettiContainer);
      }

      this.confetti = loadAnimation('confetti-animation');
    },
    closeOverlay() {
      if (this.confetti) {
        this.confetti.stop();
        this.confetti = null;
      }

      hideOverlay(`overlay-fireworks-visa`);
    },
  }
}
</script>